// @flow

import I18n from '../i18n/I18n';

// Note: we only handle DAILY on the API for now.

export default class TransferFrequency {
  static DISABLED = 'DISABLED';
  static DAILY = 'DAILY';
  static WEEKLY = 'WEEKLY';
  static MONTHLY = 'MONTHLY';

  /**
   * @return array
   */
  static getChoices() {
    return [
      {
        value: TransferFrequency.DISABLED,
        label: I18n.tr('components.frequency.DISABLED'),
      },
      {
        value: TransferFrequency.DAILY,
        label: I18n.tr('components.frequency.DAILY'),
      },
      // {
      //   value: TransferFrequency.WEEKLY
      //   label: I18n.tr('components.frequency.WEEKLY'),
      // },
      // {
      //   value: TransferFrequency.MONTHLY
      //   label: I18n.tr('components.frequency.MONTHLY'),
      // }
    ];
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/constants/TransferFrequency.js